import styled, { css } from 'styled-components';

const horFloatingBase = css`
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: var(--white-300);
  backdrop-filter: blur(15px);
`;

export const LeftAnimated = styled.div.attrs({ className: 'dsc-pageLeftWrapper' })`
  height: 100%;
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transition: all 0.3s ease-in-out;

  ${({ $floating, $visible }) =>
    $floating
      ? css`
          ${horFloatingBase};
          left: ${$visible ? '0' : '-1000px'};
          box-shadow: 6px 9px 18px -1px var(--darkJungleGreen-250);
        `
      : css`
          width: ${$visible ? 'auto' : '0'};
        `}
`;
export const RightAnimated = styled.div.attrs({ className: 'dsc-pageRightWrapper' })`
  height: 100%;
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transition: all 0.3s ease-in-out;

  ${({ $floating, $visible }) =>
    $floating
      ? css`
          ${horFloatingBase};
          right: ${$visible ? '0' : '-1000px'};
          box-shadow: -6px 9px 18px -1px var(--darkJungleGreen-250);
        `
      : css`
          width: ${$visible ? 'auto' : '0'};
        `}
`;

const verAnimationBase = css`
  max-height: ${({ $visible }) => ($visible ? '500px' : '0px')};
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transition: all 0.3s ease-in-out;
`;

export const TopAnimated = styled.div.attrs({ className: 'dsc-pageTopPanelWrapper' })`
  width: 100%;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  ${verAnimationBase};
`;

export const TopPanelArea = styled.div.attrs({ className: 'dsc-pageTopPanelArea' })`
  width: 100%;
  position: relative;
`;

export const TopPanelToggle = styled.button.attrs({ className: 'dsc-pageTopPanelToggle', type: 'button' })`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 25px;
  padding: 0;
  border: var(--page-toggle-border);
  border-radius: var(--page-toggle-radius);
  background-color: var(--page-toggle-bg);
  box-shadow: var(--page-toggle-shadow);
  cursor: pointer;
  z-index: 1;

  && .collapse-icon svg {
    color: var(--page-toggle-icon-color);
    transition: transform 0.3s ease-in-out;
    transform: ${({ $expanded }) => ($expanded ? 'rotate(90deg)' : 'rotate(270deg)')};
  }
`;

export const Container = styled.div.attrs({ className: 'dsc-page' })`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /** Container need to be relative, for BottomDrawer (when drawer is floating - despite it's placed regularly Under MainArea) */
  position: relative;
`;

export const Header = styled.div.attrs({ className: 'dsc-pageHeader' })`
  width: 100%;
  min-height: 30px;
`;
export const TopPanel = styled.div.attrs({ className: 'dsc-pageTopPanel' })`
  position: relative;
  //max-height: 150px;
`;

export const MainArea = styled.div.attrs({ className: 'dsc-pageMainArea' })`
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const MainAreaHeader = styled.div.attrs({ className: 'dsc-pageMainAreaHeader' })`
  width: 100%;
`;

export const MainAreaContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
`;

export const Content = styled.div.attrs({ className: 'dsc-pageContent' })`
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
`;

export const LeftDrawer = styled.div.attrs({ className: 'dsc-pageLeft' })`
  /* If sticky/pinned, it will push the Content right. Else it will be absolute left floating */
  height: 100%;
`;

export const RightDrawer = styled.div.attrs({ className: 'dsc-pageRight' })`
  height: 100%;
  /* If sticky/pinned, it will push the Content left. Else it will be absolute right floating */
`;

export const BottomAnimated = styled.div.attrs({ className: 'dsc-pageBottomWrapper' })`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: var(--bottom-drawer-bg, var(--blackGlaze-600));
  border-top: var(--bottom-drawer-border-top, none);
  box-shadow: var(--bottom-drawer-shadow, 9px -6px 18px -1px var(--darkJungleGreen-250));
  backdrop-filter: var(--bottom-drawer-backdrop-filter, blur(10px));
  white-space: var(--bottom-drawer-white-space, normal);
  ${verAnimationBase};
`;

export const BottomDrawer = styled.div.attrs({ className: 'dsc-pageBottom' })`
  width: 100%;
`;
